import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';

@Component({
  name: 'bpc-checkbox-group',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class CheckboxGroup extends mixins(AbstractField) {
  @Prop(Array) readonly value: string[];

  @Prop(Array) readonly options: { text: string; value: string }[];
  @Prop(Boolean) readonly skipOptionTranslation: boolean;

  get model(): string[] {
    return this.value;
  }
  set model(val: string[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }
  get translatedOptions(): object[] {
    if (this.skipOptionTranslation) {
      return this.options;
    }
    return this.options.map(option => {
      return {
        ...option,
        text: this.$t(option.text),
      };
    });
  }
}
